<template>
 <div>
     <div class="logo">
            <a href="" target="_blank"><img height="40" src="../common/images/logo.png" alt="厦门物拓科技有限公司logo"></a>
        </div>
        <nav class="navbar navbar-default nav-blue">
            <div class="navbar-header">
                <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
            </div>
            <div class="container-fluid">
                <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                    <ul class="nav navbar-nav">
                        <li><router-link to="/">首页</router-link></li>
                        <li class="dropdown">
                            <router-link :to="{path:'/BU',query: {index: 0}}" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">蓝牙超高频小精灵<span class="caret"></span></router-link>
                            <ul class="dropdown-menu">
                                <li><router-link :to="{path: '/BU/01', query: {index: 0}}">BU01</router-link></li>
                                <li><router-link :to="{path:'/BU/01KB', query: {index: 1}}">BU01KB</router-link></li>
                                <li><router-link :to="{path: '/BU/01PB', query: {index: 2}}">BU01PB</router-link></li>
                            </ul>
                        </li>
                        <li class="dropdown">
                            <router-link :to="{path:'/BH',query: {index: 0}}" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"> 蓝牙高频小精灵<span class="caret"></span></router-link>
                            <ul class="dropdown-menu">
                            	 <li><router-link  :to="{path: '/BH/04', query: {index: 0}}">BH04</router-link></li>
                            	 <li><router-link  :to="{path: '/BH/04KB', query: {index: 1}}">BH04KB</router-link></li>
                            </ul>
                        </li>
                        <li class="dropdown">
                            <router-link :to="{path:'/RU',query: {index: 0}}" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">音频口超高频小精灵<span class="caret"></span></router-link>
                            <ul class="dropdown-menu">
                                    <li><router-link  :to="{path: '/RU/02', query: {index: 0}}">RU02</router-link></li>

                                <li><router-link  :to="{path: '/RU/03', query: {index: 1}}">RU03</router-link></li>
                            </ul>
                        </li>
                        <li  class="dropdown">
                            <router-link :to="{path:'/RH',query: {index: 0}}" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">音频口高频小精灵<span class="caret"></span></router-link>
                            <ul class="dropdown-menu">
                                <li><router-link  :to="{path: '/RH/06', query: {index: 0}}">RH06</router-link></li>
                                <li><router-link :to="{path: '/RH/07', query: {index: 1}}">RH07</router-link></li>
                                <li><router-link :to="{path: '/RH/21', query: {index: 2}}">RH21</router-link></li>
                            </ul>
                        </li>
                        <li class="dropdown">
                            <router-link :to="{path:'/SMQ',query: {index: 0}}" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">扫描枪<span class="caret"></span></router-link>
                            <ul class="dropdown-menu">
                                <li><router-link :to="{path: '/SMQ/02', query: {index: 0}}">BU02</router-link></li>
                                  <li><router-link :to="{path: '/SMQ/02PB', query: {index: 1}}">BU02PB</router-link></li>
                            </ul>
                        </li>
                        <li class="dropdown">
                            <router-link :to="{path:'/BU04',query: {index: 0}}" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">掌上扫描器<span class="caret"></span></router-link>
                            <ul class="dropdown-menu">
                                <li><router-link :to="{path: '/BU04/PB', query: {index: 0}}">BU04PB</router-link></li>
                            </ul>
                        </li>
                    </ul>
                   
                </div>
            </div>
        </nav>
        
 </div>
</template>

<script>
 export default {
   data () {
     return {

     }
   },
   components: {

   }
 }
</script>

<style lang="stylus" scoped rel="stylesheet/stylus">

 .dropdown-menu
    cursor pointer
    li
     a
      &:hover
        color: #262626
        text-decoration: none
        background-color: #012369
        color: #fff
</style>



// WEBPACK FOOTER //
// src/base/header.vue